import React from 'react'

import './radio-group.css'

const RadioGroup = ({items, defaultChecked, name, onChange}) => {
    return (
        <div className="radio-group">
            {items.map(({label, value}, index) => (
                <div key={`${name}-${index}`} className="radio-group__item">
                    <label className="radio-group__label">
                        <input
                            className="radio-group__input"
                            type="radio"
                            name={name}
                            value={value}
                            defaultChecked={value === defaultChecked}
                            onChange={(ev) => onChange(ev.target.value)}
                        />
                        <div className="radio-group__input-label">{label}</div>
                    </label>
                </div>
            ))}
        </div>
    )
}

export default RadioGroup
